import {
  Chat,
  ChatParticipant,
  ChatType,
} from '@tribeplatform/gql-client/types'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { Sidebar } from '@tribeplatform/react-ui-kit/Sidebar'

import { T } from '../../i18n/index.js'
import { ChatImage } from '../components/ChatImage.js'

import { ChatActions, ChatActionsTypes } from './ChatActions.js'
import { MemberAbout } from './MemberAbout.js'

interface Props {
  participant: ChatParticipant
  chat: Chat
  onClose: () => void
}

export const ParticipantDetails = ({ participant, chat, onClose }: Props) => {
  return (
    <Sidebar size="auto" withBorder={false} className="rounded-base">
      <Sidebar.Header className="p-8 sm:pb-8 relative">
        <div className="absolute top-4 left-3">
          <IconButton
            variant="tertiaryNeutral"
            icon={<SvgIcon name="close" />}
            onClick={onClose}
          />
        </div>
        <div className="flex flex-col items-center gap-3 w-full">
          <ChatImage
            type={ChatType.Direct}
            imageUrl={participant.avatarUrl}
            name={participant.name}
            size="6x"
          />
          <div className="text-lg font-semibold text-content">
            {participant.name}
          </div>
          <Link href={`/member/${participant.memberId}`}>
            <T id="Generics.ViewProfile" defaultMessage="View profile" />
          </Link>
        </div>
      </Sidebar.Header>
      <Sidebar.Content className="p-0 border-t border-line-subdued">
        <div className="border-b border-line-subdued">
          <MemberAbout memberId={participant.memberId} />
        </div>
        <ChatActions
          peerParticipant={participant}
          chat={chat}
          actions={[ChatActionsTypes.Block]}
          title={<T id="Generics.Actions" defaultMessage="Actions" />}
        />
      </Sidebar.Content>
    </Sidebar>
  )
}
